<template>
  <NuxtLinkLocale
    :to="categoryLink"
    rel="nofollow"
    class="category-filter-item__label"
    :class="{
      'category-filter-item__label--selected': selected,
    }"
    @click.prevent
  >
    {{ name }}
    <span v-if="showCount" class="category-filter-item__value">{{ count }}</span>
  </NuxtLinkLocale>
</template>

<script setup lang="ts">
type Props = {
  name: string
  value: string
  count: number | string
  selected?: boolean
  showCount?: boolean
}

const props = defineProps<Props>()
const route = useRoute()

const categoryLink = computed(() => {
  const {
    q,
    ordering
  } = route.query
  const query: Record<string, string> = {}

  if (q && typeof q === 'string') {
    query.q = q
  }
  if (props.value) {
    query.category = props.value
  }
  if (ordering && typeof ordering === 'string') {
    query.ordering = ordering
  }
  return {
    query
  }
})

</script>

<style lang="scss">

.category-filter-item {
  $root: &;

  &__label {
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 3.3rem;
    padding: 0.6rem 0;
    position: relative;
    color: #161616;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100vw;
      right: -1.6rem;
      background-color: transparent;
      transition: background-color $transition-time;
      z-index: -1;

      @media only screen and (min-width: 740px) {
        width: auto;
        left: -1rem;
        right: -0.9rem;
      }
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1.6rem;
      width: 0;
      border-radius: 5px 0 0 5px;
      background-color: $primary-color;
      @media only screen and (min-width: 740px) {
        right: -1.3rem;
      }
    }

    &--selected {
      #{$root}__name {
        text-shadow: 0 0 0.55px $font-color;
      }

      &:before {
        background-color: rgba(231, 231, 231, 0.4);
        right: -1.3rem;
      }

      &:after {
        width: 4px;
      }
    }

    &:hover {
      &:before {
        background-color: #f6f6f6;
      }
    }

    &:not(#{$root}__label--selected) {
      #{$root}__value {
        color: $secondary-font-color;
      }
    }
  }

  &__value {
    padding-left: 0.5rem;
    flex-shrink: 0;
  }
}
</style>
